import {BaseService} from "./BaseService";
import {EmployeeLocationHistory} from "../entities/EmployeeLocationHistory";
import { StateService } from "@uirouter/angularjs";

export class EmployeeLocationHistoryService extends BaseService<EmployeeLocationHistory>{
    static $inject = ['$http','$q','$state'];
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
        super($http, $q, $state, EmployeeLocationHistory);
    }
    protected getBaseUrl():string{
        return "employeelocationhistory";
    }
    protected getBasesUrl():string{
        return "employeelocationhistories";
    }
    getByEmployee(employeeId:number):ng.IPromise<EmployeeLocationHistory[]>{
        var config:any = {};
        return this.useBaseGetArrayHandler(this.getBasesUrl(),"employee/"+employeeId, config);
    }
    getReport(groupByEmployee:boolean,firstName:string,lastName:string,email:string,location:string){
        var config:any = {
            headers: {
                'Content-type': 'application/json',
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'arraybuffer'
        };
        var timeZoneId = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return this.useGetHandler("Report", "EmployeeLocationHistory?timeZoneId=" + timeZoneId + "&groupByEmployee=" + groupByEmployee + "&firstName=" + firstName + "&lastName=" + lastName + "&email=" + email +"&location="+location, config);
    }
    getReportCount(groupByEmployee: boolean, firstName: string, lastName: string, email: string, location: string) {
        var config: any = {};
        return this.useGetHandler(this.getBasesUrl(), "ReportCount?groupByEmployee=" + groupByEmployee + "&firstName=" + firstName + "&lastName=" + lastName + "&email=" + email + "&location=" + location, config);
    }
    getReportItems(groupByEmployee: boolean, firstName: string, lastName: string, email: string, location: string): ng.IPromise<EmployeeLocationHistory[]> {
        var config: any = {};
        return this.useBaseGetArrayHandler(this.getBasesUrl(), "Report?groupByEmployee=" + groupByEmployee + "&firstName=" + firstName + "&lastName=" + lastName + "&email=" + email + "&location=" + location, config);
    }
}
